import { sendDelete, sendGet, sendPost, sendPut } from 'helper/api/axios';
import { ICompanyStaffDetailInformation } from '@pages/CompanySite/StaffManagement/useStaffManagement';
import { ISalaryAdvanceData } from '@pages/CompanySite/SalaryAdvance/interface';
import { SettingRegulationsEnum } from 'constants/constants';

interface ICompanySaveBank {
  id?: number;
  bank_code: string;
  bank_branches_code: string;
  bank_type: number;
  account_name: string;
  account_number: string;
}
interface ICompanyCreateAdmin {
  id?: number;
  full_name: string;
  name_kana: string;
  email: string;
}
interface ICompanyEditAdmin {
  id?: number;
  full_name: string;
  name_kana: string;
  email: string;
}

export const apiCompanySaveCompanyBank = (params: ICompanySaveBank) =>
  sendPost('/s3/company/save-company-bank', params);
export const apiCompanyBankDetail = () => sendGet('/s3/company/company-bank-detail');
export const apiCompanyAccountList = () => sendGet('/s3/company/account-list');
export const apiCompanyCreateAdmin = (params: ICompanyCreateAdmin) => sendPost('/s3/company/create-account', params);
export const apiCompanyEditAdmin = (id: number | undefined, params: ICompanyEditAdmin) =>
  sendPut(`/s3/company/update-account/${id}`, params);
export const apiCompanyDeleteAdmin = (id: number) => sendDelete(`/s3/company/account/${id}`);
export const apiCompanySalaryDetail = () => sendGet('/s3/company/setting-company-salary/detail');
export const apiCompanySalarySetting = (params: ISalaryAdvanceData) =>
  sendPost('/s3/company/setting-company-salary', params);
export const apiConfirmCompanySalarySetting = (params: ISalaryAdvanceData) =>
  sendGet('s3/company/check-setting-company-salary', params);
export const apiCompanyListStaff = () => sendGet('/s3/company/staff/list');
export const apiCompanyDetailStaff = (id: number) => sendGet(`/s3/company/staff/detail/${id}`);
export const apiCompanyRegulationStaff = (id: number) => sendGet(`/s3/company/staff/${id}/regulation`);
export const apiCompanyCreateStaff = (params: ICompanyStaffDetailInformation) =>
  sendPost('/s3/company/staff/create', params);
export const apiCompanyUpdateStaff = (params: ICompanyStaffDetailInformation) =>
  sendPut(`/s3/company/staff/update/${params.id}`, params);
export const apiCompanyDeleteStaff = (id: number) => sendDelete(`/s3/company/staff/delete/${id}`);
export const apiCompanyGetLastAttendance = (id: number) => sendGet(`/s3/company/staff/last-attendance/${id}`);
export const apiCompanyValidateStaffImport = (params: any) => sendPost('/s3/company/staff/validate-import', params);
export const apiCompanyCreateStaffImport = (params: any) => sendPost('/s3/company/staff/import', params);
export const apiGetCompanyProfile = () => sendGet('/s3/company/info');
export const apiAdminEditCompanySiteProfile = (params: any) => sendPut('/s3/company/update', params);
export const apiAdminGetAttendance = (params: any) => sendGet(`/s3/time-attendance`, params);
export const apiAdminGetAttendanceOneStaff = (params: any) =>
  sendGet(`/s3/time-attendance/staff/${params.staff_id}`, params);

export const apiAdminSetTimeAttendance = (params: any) => sendPost(`/s3/time-attendance/create`, params);
export const apiCompanyUploadFile = (data: FormData) => sendPost('/s3/company/upload-file', data);
export const apiCompanySaveDocumentFile = (data: any) => sendPost('/s3/company/save-document-file', data);
export const apiCompanyRelatedInformation = () => sendGet('/s3/company/related-information');
export const apiCompanySettingSalaryLast = () => sendGet('/s3/company/company-setting-salary-last');

export const apiCompanyB2BByEmail = (email: string) => sendGet(`/s3/company/company/b2b/${email}`);
export const apiCompanyB2BCreate = (params: any) => sendPost('/s3/company-b2b/create', params);
export const apiListCompanyB2B = (params?: any) => sendGet('/s3/company-b2b', params);
export const apiListCompanyB2BPaired = (params?: any) => sendGet('/s3/company-b2b/list', params);
export const apiChangeStatusB2B = (id: number, params?: any) => sendPut(`/s3/company-b2b/status/update/${id}`, params);
export const apiCompanyInviteStaffB2C = (params: { email: string }) => sendPost('/s3/company-b2c/invite', params);
export const apiCompanyDeleteLinkB2C = (id: number) => sendDelete(`/s3/company-b2c/${id}`);

export const apiGetRequestSalary = (params: any) => sendGet('/s3/salary-request/list', params);
export const apiApproveRequestSalary = (params: any) => sendPost('/s3/salary-request/approved', params);
export const apiCancelRequestSalary = (params: any) => sendPost('/s3/salary-request/cancel', params);

export const apiGetHistoryAllStaff = (params: any) => sendGet('/s3/staff/transaction/salary-advance', params);
export const apiGetHistoryAllStaffDetail = (staffId: any, params: any) =>
  sendGet(`/s3/staff/transaction/salary-advance/${staffId}/detail`, params);
export const apiGetHistoryAdvanceAllDataStaffExport = (params: any) =>
  sendGet('/s3/staff/transaction/salary-advance/all-data', params);
export const apiGetHistoryAdvanceDataOfStaffExport = (params: any, staffId: any) =>
  sendGet(`/s3/staff/transaction/salary-advance/${staffId}/data`, params);

export const getCompanyChatMessages = (page: number) => sendGet(`/s3/chat-message/list?page=${page}`);
export const getTotalCompanyChatMessages = () => sendGet('/s3/chat-message/total');
export const getCompanyCountChatMessagesNotRead = () => sendGet('/s3/chat-message/count-message-not-read');
export const readAllCompanyChatMessages = () => sendPost('/s3/chat-message/read-all');
export const notifyNewChatMessage = (params: any) => sendPost('/s3/chat-message/notify-new-message', params);

export const apiGetListNoticeCompany = (params: any) => sendGet('/s3/message/list', params);
export const aoiGetDetailNoticeCompany = (id: string | undefined) => sendGet(`/s3/message/${id}`);
export const apiCompanyFootstepsHistory = (params: any) => sendGet('s3/history-action/list', params);
export const apiCompanyCalendarTopPage = (params: any) => sendGet('s3/staff/salary-request/total-request', params);

export const apiCompanyTotalNotMark = () => sendGet('s3/time-attendance/total-not-mark');
export const apiCompanyTotalNotSettingPayment = () => sendGet('s3/company-b2c/total-not-setting-payment');
export const apiCompanyTotalNotHandle = () => sendGet('s3/salary-request/total-not-handle');
export const apiCompanyChartTopPage = (prams: any) => sendGet('s3/staff/salary-request/total-request/month', prams);

export const apiGetListInvoice = (params: any) => sendGet('s3/invoice/list', params);
export const apiGetInvoiceDetail = (id: any, params: { offset?: number; per_page?: number }) =>
  sendGet(`/s3/invoice/detail/${id}`, params);

export const apiGetDetailRequestCompany = (id: any) => sendGet(`/s3/salary-request/detail/${id}`);
export const apiGetLastAgreedRegulationsOfStaff = (staffId: number) =>
  sendGet('/api/user/last-agreed-regulation', {
    staff_id: staffId,
    type: SettingRegulationsEnum.TYPE_OPERATOR_STAFF,
  });
export const apiListInvoiceCompanyDetail = (params: any) => sendGet('s3/invoice/company-paired', params);
export const apiRefreshExpireFirstTime = (staffId: number, params?: any) =>
  sendPut(`s3/company/staff/refresh-expire-first-time/${staffId}`, params);
